{
  "price_min": "Preț minim",
  "price_max": "Preț maxim",
  "year_min": "An minim",
  "year_max": "An maxim",
  "mileage_min": "Kilometraj minim",
  "mileage_max": "Kilometraj maxim",
  "fuel": "Combustibil",
  "transmission": "Cutie",
  "rhd": "Volan dreapta",
  "mot_valid_until": "MOT valabil până la",
  "ulez_compliant": "Compatibil ULEZ",
  "euro_norm": "Normă Euro",
  "make": "Marcă",
  "model": "Model",
  "body_type": "Caroserie",
  "color": "Culoare",
  "doors": "Uși",
  "seats": "Locuri",
  "power_min": "Putere minimă",
  "power_max": "Putere maximă",
  "condition": "Stare",
  "new": "Nou",
  "used": "Second-hand",
  "damaged": "Avariat",
  "all_countries": "Toate țările",
  "fuel_petrol": "Benzină",
  "fuel_diesel": "Diesel",
  "fuel_electric": "Electric",
  "fuel_hybrid": "Hibrid",
  "fuel_lpg": "GPL",
  "fuel_plugin_hybrid": "Hibrid Plugin",
  "transmission_manual": "Manuală",
  "transmission_automatic": "Automată",
  "transmission_semiautomatic": "Semiautomată",
  "select_make": "Alege marcă",
  "select_model": "Alege model",
  "operating_hours_min": "Ore motor min",
  "operating_hours_max": "Ore motor max",
  "tonnage_min": "Tonaj minim",
  "tonnage_max": "Tonaj maxim",
  "bucket_capacity_min": "Capacitate cupă min",
  "bucket_capacity_max": "Capacitate cupă max",
  "pto_hp": "PTO (HP)",
  "working_width": "Lățime lucru",
  "length_min": "Lungime min (m)",
  "length_max": "Lungime max (m)",
  "beam_min": "Lățime min (m)",
  "beam_max": "Lățime max (m)",
  "draft_min": "Pescaj min (m)",
  "draft_max": "Pescaj max (m)",
  "engine_year_min": "An motor min",
  "engine_year_max": "An motor max",
  "marina": "Marină / Port",
  "category": "Categorie",
  "price": "Preț",
  "year": "An",
  "search": "Caută",
  "loading_makes": "Se încarcă...",
  "up_to": "Până la",
  "from_year": "Din",
  "sort_newest": "Cele mai noi",
  "sort_price_asc": "Preț crescător",
  "sort_price_desc": "Preț descrescător",
  "sort_year_desc": "An (mai noi primii)",
  "sort_year_asc": "An (mai vechi primii)",
  "sort_km_asc": "Kilometraj crescător",
  "sort_km_desc": "Kilometraj descrescător",
  "sort_placeholder": "Sortează după...",
  "cat_cars": "Autoturisme",
  "cat_trucks": "Camioane",
  "cat_vans": "Autoutilitare",
  "cat_motorcycles": "Motociclete",
  "cat_boats": "Ambarcațiuni",
  "cat_construction": "Utilaje",
  "cat_agricultural": "Tractoare",
  "cat_atv": "ATV",
  "active_filters": "Filtre active",
  "clear_all": "Șterge tot",
  "results_found": "rezultate",
  "no_active_filters": "Niciun filtru activ — explorează toate vehiculele",
  "to_year": "Până în",
  "shop_by_category": "Cumpără după categorie",
  "shop": "Vezi",
  "cat_cars_sub": "Berline, SUV, coupé",
  "cat_vans_sub": "Transport marfă",
  "cat_moto_sub": "Sport, touring, scuter",
  "cat_trucks_sub": "Cap tractor & remorci",
  "cat_boats_sub": "Bărci, iahturi, jet ski",
  "cat_construction_sub": "Excavatoare, încărcătoare",
  "cat_agricultural_sub": "Agricole & utilaje",
  "more_filters": "Mai multe filtre",
  "fewer_filters": "Mai puține filtre",
  "any": "Oricare",
  "section_technical": "Tehnice",
  "section_appearance": "Aspect și stare",
  "section_seller": "Vânzător și dotări",
  "drive_type": "Tracțiune",
  "drive_fwd": "Față (FWD)",
  "drive_rwd": "Spate (RWD)",
  "drive_awd": "Integrală (AWD/4x4)",
  "seller_type": "Tip vânzător",
  "seller_dealer": "Dealer",
  "seller_private": "Persoană fizică",
  "condition_technical": "Stare tehnică",
  "cond_excellent": "Excelentă",
  "cond_very_good": "Foarte bună",
  "cond_good": "Bună",
  "cond_average": "Medie",
  "features": "Dotări",
  "city": "Oraș",
  "body_suv": "SUV",
  "body_sedan": "Berlină",
  "body_hatchback": "Hatchback",
  "body_estate": "Break",
  "body_coupe": "Coupé",
  "body_cabrio": "Cabrio",
  "body_minivan": "Monovolum",
  "body_pickup": "Pick-up",
  "color_alb": "Alb",
  "color_negru": "Negru",
  "color_gri": "Gri",
  "color_argintiu": "Argintiu",
  "color_albastru": "Albastru",
  "color_rosu": "Roșu",
  "color_verde": "Verde",
  "color_galben": "Galben",
  "color_maro": "Maro",
  "color_portocaliu": "Portocaliu",
  "color_auriu": "Auriu",
  "feat_ac": "Aer condiționat",
  "feat_climate_control": "Climatronic",
  "feat_navigation": "Navigație",
  "feat_cruise_control": "Pilot automat",
  "feat_parking_sensors_rear": "Senzori parcare spate",
  "feat_led_headlights": "Faruri LED",
  "feat_alloy_wheels": "Jante aliaj",
  "feat_bluetooth": "Bluetooth",
  "feat_isofix": "ISOFIX",
  "feat_lane_assist": "Asistență bandă"
}
